import * as c from "@/constants/userTypes";
import Vue    from 'vue';
import store  from "@/store/store";

const aclChecks = {
  isClient:        ( userType ) => userType === c.USER_TYPE_CLIENT,
  isMcAdmin:       ( userType ) => userType === c.USER_TYPE_MC_ADMIN,
  isEmployee:      ( userType ) => userType === c.USER_TYPE_EMPLOYEE,
  isAdmin:         ( userType ) => userType === c.USER_TYPE_ADMIN,
  isHouseImporter: ( userType ) => userType === c.USER_TYPE_HOUSE_IMPORTER,
};

const acl = {
  check: ( type ) => {
    return aclChecks[type] ? aclChecks[type](store.getters['appUser/type']) : false;
  },
};

Vue.prototype.$acl = acl;

export default acl;
